import { createSvgIcon } from '@mui/material';

export default createSvgIcon(
  <path d="M16.023,5.028c0.4,0.055,0.787,0.19,1.136,0.4l2.604,1.562L19.36,9H19h-2v2v8H7v-8V9H5H4.64L4.238,6.99l2.604-1.562 c0.349-0.209,0.736-0.345,1.136-0.4C8.821,6.013,10.184,7,12,7S15.179,6.013,16.023,5.028 M15.615,3H15c0,0-1,2-3,2S9,3,9,3H8.385 C7.479,3,6.59,3.246,5.812,3.713L2,6l1,5h2v10h14V11h2l1-5l-3.812-2.287C17.41,3.246,16.521,3,15.615,3L15.615,3z" />,
  'TShirtOutlined'
);
